import { render, staticRenderFns } from "./AddOrgainvent.vue?vue&type=template&id=4c3cdd7d&scoped=true&"
import script from "./AddOrgainvent.vue?vue&type=script&lang=js&"
export * from "./AddOrgainvent.vue?vue&type=script&lang=js&"
import style0 from "./AddOrgainvent.vue?vue&type=style&index=0&id=4c3cdd7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3cdd7d",
  null
  
)

export default component.exports